import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgIcon } from '#components'
const lazyGlobalComponents = [
  ["SvgIcon", LazySvgIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
